import { Money } from '@betterment/core';

import { DuringMarketHours } from './highlight-section/DuringMarketHours';
import { PostMarketHours } from './highlight-section/PostMarketHours';
import { PreMarketHours } from './highlight-section/PreMarketHours';

import { DateRangeOption } from '../../../../../../graphql/schema';
import { type MarketScheduleType, singleDayMarketScheduleHours } from '../marketSchedule';

type PerformanceSingleDayOpenType = {
  latestPriceAmount: Money;
  latestReturnsAmount: Money;
  latestReturnsPercentage: number;
  marketSchedule: MarketScheduleType;
  dateRangeOption: DateRangeOption;
  currentDate: Date;
};

export const PerformanceSingleDayOpen = ({
  latestPriceAmount,
  latestReturnsAmount,
  latestReturnsPercentage,
  marketSchedule,
  dateRangeOption,
  currentDate,
}: PerformanceSingleDayOpenType) => {
  const { isPreMarketHours, isPostMarketHours, isDuringMarketHours } = singleDayMarketScheduleHours({
    currentDate,
    marketSchedule,
  });

  if (isDuringMarketHours) {
    return (
      <DuringMarketHours
        latestPriceAmount={latestPriceAmount}
        latestReturnsAmount={latestReturnsAmount}
        latestReturnsPercentage={latestReturnsPercentage}
        dateRangeOption={dateRangeOption}
      />
    );
  }

  if (isPreMarketHours) {
    return (
      <PreMarketHours currentDate={currentDate} latestPriceAmount={latestPriceAmount} marketSchedule={marketSchedule} />
    );
  }

  if (isPostMarketHours) {
    return (
      <PostMarketHours
        latestPriceAmount={latestPriceAmount}
        latestReturnsAmount={latestReturnsAmount}
        latestReturnsPercentage={latestReturnsPercentage}
        dateRangeOption={dateRangeOption}
      />
    );
  }

  return null;
};
